export default {
  // 提问
  chat(data) {
    return this.http('Gpt', 'post', '/gpt-core/api.v1.NutritionistRpc/Chat', data);
  },
  // 获取列表
  chatList(data) {
    return this.http('Gpt', 'post', '/gpt-core/api.v1.NutritionistRpc/ChatList', data);
  },
  // 更新状态
  updateResponseState(data) {
    return this.http('Gpt', 'post', '/gpt-core/api.v1.NutritionistRpc/UpdateResponseState', data);
  },
  // 用户的sop数据
  userSop(data) {
    return this.http('Gpt', 'post', '/gpt-core/api.v1.NutritionistRpc/GetUserPhaseInfo', data);
  },
  // 修改用户sop阶段
  ChangeUserSop(data) {
    return this.http('Gpt', 'post', '/gpt-core/api.v1.NutritionistRpc/ChangeUserPhaseInfo', data);
  },
  // 更新聊天内容
  UpdateChat(data) {
    return this.http('Gpt', 'post', '/gpt-core/api.v1.NutritionistRpc/UpdateChat', data);
  },
  // 生成追问与结合回答
  GenerateProbingAndCombining(data) {
    return this.http('Gpt', 'post', '/gpt-core/api.v1.NutritionistRpc/GenerateProbingAndCombining', data);
  },
  Prompt(data) {
    return this.http('BOX_CRON', 'get', '/api/v1/service/chat/prompt', data);
  },
  LLMChatList(data) {
    return this.http('LLM', 'get', '/api/v1/nutritionist/chat_list', data);
  },
  LLMChatCompletion(data) {
    return this.http('LLM', 'post', '/api/v1/chat/completion', data);
  }
};
